import { getExampleNumber } from "libphonenumber-js"
import examples from "libphonenumber-js/mobile/examples"

export const getPhoneMaxLength = (countryCode = "US") => {
  try {
    const example = getExampleNumber(countryCode, examples)

    if (!example) return 15

    return example.nationalNumber.length
  } catch {
    return 15
  }
}
